export const testPolicyName = 'testpolicy';
export const policyName = 'Policies';
export const bdxName = 'BDX';

// Feature flag for Change Group functionality
// Set to true to enable the Change Group feature when ready
export const ENABLE_CHANGE_GROUP_FEATURE = true;

export const policyStatusEditCurrency = [
  'Draft',
  'Quoted',
  'SPAQuoted',
  'SpaQuoteRequestedByClient',
  'SPAQuoteRequested',
  'SPAQuotedQRS',
];
export const policyStatusAll = [
  'SpaQuoteRequestedByClient',
  'SPAQuoteRequested',
  'SPAQuoted',
  'SPAQuotedQRS',
  'Draft',
  'DraftEndorsement',
  'Quoted',
  'QuotedEndorsement',
  'ScheduledEndorsement',
  'Bound',
  'Endorsement',
  'Expired',
  'FlatCancel',
  'ProRataCancel',
  'Declined',
];
export const policyStatusSPAflow = [
  'SpaQuoteRequestedByClient',
  'SPAQuoteRequested',
  'SPAQuoted', //on send to client btn click
  'SPAQuotedQRS', //on Price btn click
];
export const policyStatusDraft = [
  'Draft',
  'DraftEndorsement',
  'Quoted',
  'QuotedEndorsement',
];
export const policyStatusBound = [
  'Bound',
  'Endorsement',
  'ScheduledEndorsement',
];
export const policyStatusInactive = [
  'Draft',
  'DraftEndorsement',
  'Quoted',
  'QuotedEndorsement',
  'SPAQuoted',
  'Expired',
  'FlatCancel',
  'ProRataCancel',
  'Declined',
  'SPAQuoteRequested',
  'SpaQuoteRequestedByClient',
];

// Statuses at which at least one location must be for the Download Documents action to appear.
export const DOWNLOAD_DOCUMENTS_ELIGIBLE_STATUSES = [
  'Quoted',
  'SPAQuoted',
  'QuotedEndorsement',
  'Bound',
  'Endorsement',
  'ScheduledEndorsement',
  'DraftEndorsement',
  'Expired',
  'FlatCancel',
  'ProRataCancel',
  'Declined',
];

// Statuses that must NOT appear as rows in the Download Documents modal's Locations table (no documents yet).
export const DOWNLOAD_DOCUMENTS_HIDDEN_LOCATION_STATUSES = [
  'Draft',
  'DraftEndorsement',
  'SpaQuoteRequestedByClient',
  'SPAQuoteRequested',
  'SPAQuotedQRS',
];

// UI doc types mapped to backend PolicyTransactionType values.
export const DOWNLOAD_DOCUMENT_TYPES = [
  { id: 'Quote', label: 'Quote', transactionTypes: ['Quoted', 'SPAQuoted'] },
  { id: 'Certificate', label: 'Certificate', transactionTypes: ['Bound'] },
  {
    id: 'Endorsement',
    label: 'Endorsement',
    transactionTypes: ['Endorsed', 'ScheduledEndorsement'],
  },
  {
    id: 'Cancellation',
    label: 'Cancellation',
    transactionTypes: [
      'ProRataCancelled',
      'FlatCancelled',
      'ScheduledCancelled',
    ],
  },
];
export const policyStatusCombined = {
  all: policyStatusAll.toString(),
  spapendingapproval: policyStatusSPAflow.toString(),
  draft: policyStatusDraft.toString(),
  bound: policyStatusBound.toString(),
  inactive: policyStatusInactive.toString(),
  unlinked: policyStatusAll.toString(),
};

export const SPA_POLICY_TYPE = {
  NONE: 0,
  SPOT_FAC: 'SPOT_FAC',
  BLANKET: 'BLANKET',
  SCHEDULED: 'SCHEDULED',
};

export const SPA_POLICY_TYPE_OPTIONS = [
  { label: 'Spot Fac', value: SPA_POLICY_TYPE.SPOT_FAC },
  { label: 'Blanket', value: SPA_POLICY_TYPE.BLANKET },
  { label: 'Scheduled', value: SPA_POLICY_TYPE.SCHEDULED },
];

export const SPA_POLICY_TYPE_MAPPING = {
  [SPA_POLICY_TYPE.SPOT_FAC]: 'Spot Fac',
  [SPA_POLICY_TYPE.BLANKET]: 'Blanket',
  [SPA_POLICY_TYPE.SCHEDULED]: 'Scheduled',
};

export const CAT_BASIS = {
  NONE: 0,
  PER_OCCURRENCE: 'PerOccurrence',
  PER_RISK: 'PerRisk',
};

export const CAT_BASIS_OPTIONS = [
  { label: 'Per Occurrence', value: CAT_BASIS.PER_OCCURRENCE },
  { label: 'Per Risk', value: CAT_BASIS.PER_RISK },
];

export const statusAllowedForCopy = [
  'Draft',
  'Quoted',
  'Bound',
  'Endorsement',
  'QuotedEndorsement',
  'ScheduledEndorsement',
  'Declined',
  'Expired',
  'FlatCancel',
  'ProRataCancel',
  'SpaQuoteRequestedByClient',
  'SPAQuoteRequested',
  'SPAQuoted',
  'SPAQuotedQRS',
];

export const statusAllowedForExchangeRate = ['Draft'];

export const showBoundIndicatorStatuses = [
  'SPAQuoted',
  // 'QuotedEndorsement'
  // 'Quoted',
  // 'ScheduledEndorsement',
  // 'Bound',
  // 'Endorsement',
  // 'Expired',
  // 'FlatCancel',
  // 'ProRataCancel'
];

export const policyStatusOptions = [
  {
    value: 'Draft|DraftEndorsement',
    label: 'Draft',
    tab: 'draft',
  },
  //  {
  //    value: 'DraftEndorsement',
  //    label: 'Draft Endorsement',
  //    tab: 'draft'
  //  },
  {
    value: 'Quoted|QuotedEndorsement',
    label: 'Quoted',
    tab: 'draft',
  },
  //  {
  //    value: 'QuotedEndorsement',
  //    label: 'Quoted Endorsement'
  //  },
  {
    value: 'Bound|Endorsement',
    label: 'Bound',
    tab: 'bound',
  },
  // {
  //   value: 'Endorsement',
  //   label: 'Bound Endorsement',
  //   tab: 'bound'
  // },
  {
    value: 'ScheduledEndorsement',
    label: 'Scheduled',
    tab: 'bound',
  },
  {
    value: 'Expired',
    label: 'Expired',
    tab: 'inactive',
  },
  {
    value: 'FlatCancel|ProRataCancel',
    label: 'Cancelled',
    tab: 'inactive',
  },
  {
    value: 'Declined',
    label: 'Declined',
    tab: 'inactive',
  },
  //  {
  //    value: 'ProRataCancel',
  //    label: 'Pro Rata Cancel',
  //    tab: 'inactive'
  //  },
  {
    value: 'SpaQuoteRequestedByClient|SPAQuoteRequested',
    label: 'SPA Submitted',
    tab: 'spapendingapproval',
  },
  //  {
  //    value: 'SPAQuoteRequested',
  //    label: 'SPA Quote Requested (QRS)',
  //    tab: 'spapendingapproval'
  //  },
  {
    value: 'SPAQuotedQRS',
    label: 'SPA Quoted in QRS',
    tab: 'spapendingapproval',
  },
  {
    value: 'SPAQuoted',
    label: 'SPA Quoted',
    tab: 'spapendingapproval',
  },
];

export const reportingPolicyStatusOptions = [
  {
    value: 'Draft',
    label: 'Draft',
  },
  {
    value: 'Quoted',
    label: 'Quoted',
  },
  {
    value: 'SPAQuoted',
    label: 'SPA Quoted',
  },
  {
    value: 'Bound',
    label: 'Bound',
  },
  {
    value: 'Endorsement',
    label: 'Bound Endorsement',
  },
  {
    value: 'FlatCancel',
    label: 'Flat Cancel',
  },
  {
    value: 'ProRataCancel',
    label: 'Pro Rata Cancel',
  },
  {
    value: 'SPAQuotedQRS',
    label: 'SPA Submitted',
  },
];

export const optionsNetGross = [
  { value: 'Net', label: 'Net' },
  { value: 'Gross', label: 'Gross' },
];

export const perils = [
  'fire',
  'hurricane',
  'earthquake',
  'flood',
  'boiler',
  'terrorism',
];

export const perilAbreviations = [
  {
    peril: 'fire',
    abrev: 'F',
  },
  {
    peril: 'hurricane',
    abrev: 'HU',
  },
  {
    peril: 'earthquake',
    abrev: 'EQ',
  },
  {
    peril: 'flood',
    abrev: 'FL',
  },
  {
    peril: 'boiler',
    abrev: 'B',
  },
  {
    peril: 'terrorism',
    abrev: 'T',
  },
];

export const coveragesToSet = [
  'Building',
  'Contents',
  'Stock',
  'Equipment',
  'PropertyDamage',
  'BusinessInterruption',
  'ExtraExpense',
];

export const detailsToSet = {
  Occupancy: {
    label: 'occupancyName',
  },
  NumberOfStories: { label: 'storiesCount', transform: (v) => parseInt(v) }, //storiesCount
  FloorArea: { label: 'floorArea' },
  YearBuilt: { label: 'yearBuilt' },
  Construction: { label: 'construction' },
  ProtectionClass: { label: 'protectionClass', transform: (v) => parseInt(v) },
  BuildingsCount: { label: 'buildingNumber', transform: (v) => parseInt(v) }, // buildingNumber
  Sprinkler: {
    label: 'sprinklerPct',
    transform: (v) => (v === 'N' ? 0 : 100),
  }, //sprinklerPct, sprinklerAdequacy
  CentralStationAlarm: {
    label: 'centralAlarm',
    transform: (v) => (v === 'N' ? false : true),
  },
};

//maxlength in db
export const zipCodeMaxLength = 8;
export const stateMaxLength = 64;

export const countryCodes = [
  { value: 'AD', label: 'Andorra' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'AF', label: 'Afghanistan' },
  {
    value: 'AG',
    label: 'Antigua and Barbuda',
  },
  {
    value: 'AI',
    label: 'Anguilla',
  },
  {
    value: 'AL',
    label: 'Albania',
  },
  {
    value: 'AM',
    label: 'Armenia',
  },
  {
    value: 'AN',
    label: 'Netherlands Antilles',
  },
  {
    value: 'AO',
    label: 'Angola',
  },
  {
    value: 'AQ',
    label: 'Antarctica',
  },
  {
    value: 'AR',
    label: 'Argentina',
  },
  {
    value: 'AS',
    label: 'American Samoa',
  },
  {
    value: 'AT',
    label: 'Austria',
  },
  {
    value: 'AU',
    label: 'Australia',
  },
  {
    value: 'AW',
    label: 'Aruba',
  },
  {
    value: 'AZ',
    label: 'Azerbaijan',
  },
  {
    value: 'BA',
    label: 'Bosnia Herzegowina',
  },
  {
    value: 'BB',
    label: 'Barbados',
  },
  {
    value: 'BD',
    label: 'Bangladesh',
  },
  {
    value: 'BE',
    label: 'Belgium',
  },
  {
    value: 'BF',
    label: 'Burkina Faso',
  },
  {
    value: 'BG',
    label: 'Bulgaria',
  },
  {
    value: 'BH',
    label: 'Bahrain',
  },
  {
    value: 'BI',
    label: 'Burundi',
  },
  {
    value: 'BJ',
    label: 'Benin',
  },
  {
    value: 'BL',
    label: 'Saint Barthelemy',
  },
  {
    value: 'BM',
    label: 'Bermuda',
  },
  {
    value: 'BN',
    label: 'Brunei Darussalam',
  },
  {
    value: 'BO',
    label: 'Bolivia',
  },
  {
    value: 'BQ',
    label: 'Bonaire',
  },
  {
    value: 'BR',
    label: 'Brazil',
  },
  {
    value: 'BS',
    label: 'Bahamas',
  },
  {
    value: 'BT',
    label: 'Bhutan',
  },
  {
    value: 'BV',
    label: 'Bouvet Island',
  },
  {
    value: 'BW',
    label: 'Botswana',
  },
  {
    value: 'BY',
    label: 'Belarus',
  },
  {
    value: 'BZ',
    label: 'Belize',
  },
  {
    value: 'CA',
    label: 'Canada',
  },
  {
    value: 'CC',
    label: 'Cocos (Keeling)',
  },
  {
    value: 'CF',
    label: 'Central African Rep',
  },
  {
    value: 'CG',
    label: 'Congo',
  },
  {
    value: 'CH',
    label: 'Switzerland',
  },
  {
    value: 'CI',
    label: "Cote d'Ivoire",
  },
  {
    value: 'CK',
    label: 'Cook Islands',
  },
  {
    value: 'CL',
    label: 'Chile',
  },
  {
    value: 'CM',
    label: 'Cameroon',
  },
  {
    value: 'CN',
    label: 'China',
  },
  {
    value: 'CO',
    label: 'Colombia',
  },
  {
    value: 'CR',
    label: 'Costa Rica',
  },
  {
    value: 'CU',
    label: 'Cuba',
  },
  {
    value: 'CV',
    label: 'Cape Verde',
  },
  {
    value: 'CW',
    label: 'Curacao',
  },
  {
    value: 'CX',
    label: 'Christmas Island',
  },
  {
    value: 'CY',
    label: 'Cyprus',
  },
  {
    value: 'CZ',
    label: 'Czech Rep',
  },
  {
    value: 'DE',
    label: 'Germany',
  },
  {
    value: 'DJ',
    label: 'Djubouti',
  },
  {
    value: 'DK',
    label: 'Denmark',
  },
  {
    value: 'DM',
    label: 'Dominica',
  },
  {
    value: 'DO',
    label: 'Dominican Rep',
  },
  {
    value: 'DZ',
    label: 'Algeria',
  },
  {
    value: 'EC',
    label: 'Ecuador',
  },
  {
    value: 'EE',
    label: 'Estonia',
  },
  {
    value: 'EG',
    label: 'Egypt',
  },
  {
    value: 'EH',
    label: 'Western Sahara',
  },
  {
    value: 'EI',
    label: 'Eire',
  },
  {
    value: 'ER',
    label: 'Eritrea',
  },
  {
    value: 'ES',
    label: 'Spain',
  },
  {
    value: 'ET',
    label: 'Ethiopia',
  },
  {
    value: 'FI',
    label: 'Finland',
  },
  {
    value: 'FJ',
    label: 'Fiji',
  },
  {
    value: 'FK',
    label: 'Falkland Islands',
  },
  {
    value: 'FM',
    label: 'Micronesia',
  },
  {
    value: 'FO',
    label: 'Faroe Islands',
  },
  {
    value: 'FR',
    label: 'France',
  },
  {
    value: 'FX',
    label: 'France, Metro',
  },
  {
    value: 'GA',
    label: 'Gabon',
  },
  {
    value: 'GB',
    label: 'United Kingdom',
  },
  {
    value: 'GD',
    label: 'Grenada',
  },
  {
    value: 'GE',
    label: 'Georgia',
  },
  {
    value: 'GF',
    label: 'French Guiana',
  },
  {
    value: 'GH',
    label: 'Ghana',
  },
  {
    value: 'GI',
    label: 'Gibraltar',
  },
  {
    value: 'GL',
    label: 'Greenland',
  },
  {
    value: 'GM',
    label: 'Gambia',
  },
  {
    value: 'GN',
    label: 'Guinea',
  },
  {
    value: 'GP',
    label: 'Guadeloupe',
  },
  {
    value: 'GQ',
    label: 'Equatorial Guinea',
  },
  {
    value: 'GR',
    label: 'Greece',
  },
  {
    value: 'GS',
    label: 'South Georgia',
  },
  {
    value: 'GT',
    label: 'Guatemala',
  },
  {
    value: 'GU',
    label: 'Guam',
  },
  {
    value: 'GW',
    label: 'Guinea-Bissau',
  },
  {
    value: 'GY',
    label: 'Guyana',
  },
  {
    value: 'HK',
    label: 'Hong Kong',
  },
  {
    value: 'HM',
    label: 'Heard and McDonald',
  },
  {
    value: 'HN',
    label: 'Honduras',
  },
  {
    value: 'HR',
    label: 'Croatia (Hrvatska)',
  },
  {
    value: 'HT',
    label: 'Haiti',
  },
  {
    value: 'HU',
    label: 'Hungary',
  },
  {
    value: 'ID',
    label: 'Indonesia',
  },
  {
    value: 'IE',
    label: 'Ireland',
  },
  {
    value: 'IL',
    label: 'Israel',
  },
  {
    value: 'IN',
    label: 'India',
  },
  {
    value: 'IO',
    label: 'British Indian Ocean',
  },
  {
    value: 'IQ',
    label: 'Iraq',
  },
  {
    value: 'IR',
    label: 'Iran',
  },
  {
    value: 'IS',
    label: 'Iceland',
  },
  {
    value: 'IT',
    label: 'Italy',
  },
  {
    value: 'JM',
    label: 'Jamaica',
  },
  {
    value: 'JO',
    label: 'Jordan',
  },
  {
    value: 'JP',
    label: 'Japan',
  },
  {
    value: 'KE',
    label: 'Kenya',
  },
  {
    value: 'KG',
    label: 'Kyrgyzstan',
  },
  {
    value: 'KH',
    label: 'Cambodia',
  },
  {
    value: 'KI',
    label: 'Kiribati',
  },
  {
    value: 'KM',
    label: 'Comoros',
  },
  {
    value: 'KN',
    label: 'Saint Kitts and Nevis',
  },
  {
    value: 'KP',
    label: 'Korea, North',
  },
  {
    value: 'KR',
    label: 'Korea, South',
  },
  {
    value: 'KV',
    label: 'Kosovo',
  },
  {
    value: 'KW',
    label: 'Kuwait',
  },
  {
    value: 'KY',
    label: 'Cayman Islands',
  },
  {
    value: 'KZ',
    label: 'Kazakhstan',
  },
  {
    value: 'LA',
    label: 'Laos',
  },
  {
    value: 'LB',
    label: 'Lebanon',
  },
  {
    value: 'LC',
    label: 'Saint Lucia',
  },
  {
    value: 'LI',
    label: 'Liechtenstein',
  },
  {
    value: 'LK',
    label: 'Sri Lanka',
  },
  {
    value: 'LR',
    label: 'Liberia',
  },
  {
    value: 'LS',
    label: 'Lesotho',
  },
  {
    value: 'LT',
    label: 'Lithuania',
  },
  {
    value: 'LU',
    label: 'Luxembourg',
  },
  {
    value: 'LV',
    label: 'Latvia',
  },
  {
    value: 'LY',
    label: 'Libyan Arab',
  },
  {
    value: 'MA',
    label: 'Morocco',
  },
  {
    value: 'MC',
    label: 'Monaco',
  },
  {
    value: 'MD',
    label: 'Moldova',
  },
  {
    value: 'ME',
    label: 'Montenegro',
  },
  {
    value: 'MF',
    label: 'Saint Martin',
  },
  {
    value: 'MG',
    label: 'Madagascar',
  },
  {
    value: 'MH',
    label: 'Marshall Islands',
  },
  {
    value: 'MK',
    label: 'Macedona',
  },
  {
    value: 'ML',
    label: 'Mali',
  },
  {
    value: 'MN',
    label: 'Mongolia',
  },
  {
    value: 'MN',
    label: 'Myanmar',
  },
  {
    value: 'MO',
    label: 'Macau',
  },
  {
    value: 'MP',
    label: 'Northern Mariana',
  },
  {
    value: 'MQ',
    label: 'Martinique',
  },
  {
    value: 'MR',
    label: 'Mauritania',
  },
  {
    value: 'MS',
    label: 'Montserrat',
  },
  {
    value: 'MT',
    label: 'Malta',
  },
  {
    value: 'MU',
    label: 'Mauritius',
  },
  {
    value: 'MV',
    label: 'Maldives',
  },
  {
    value: 'MW',
    label: 'Malawi',
  },
  {
    value: 'MX',
    label: 'Mexico',
  },
  {
    value: 'MY',
    label: 'Malaysia',
  },
  {
    value: 'MZ',
    label: 'Mozambique',
  },
  {
    value: 'NA',
    label: 'Namibia',
  },
  {
    value: 'NC',
    label: 'New Caledonia',
  },
  {
    value: 'NE',
    label: 'Niger',
  },
  {
    value: 'NF',
    label: 'Norfolk Island',
  },
  {
    value: 'NG',
    label: 'Nigeria',
  },
  {
    value: 'NI',
    label: 'Nicaragua',
  },
  {
    value: 'NL',
    label: 'Netherlands',
  },
  {
    value: 'NO',
    label: 'Norway',
  },
  {
    value: 'NP',
    label: 'Nepal',
  },
  {
    value: 'NR',
    label: 'Nauru',
  },
  {
    value: 'NU',
    label: 'Niue',
  },
  {
    value: 'NZ',
    label: 'New Zealand',
  },
  {
    value: 'OM',
    label: 'Oman',
  },
  {
    value: 'PA',
    label: 'Panama',
  },
  {
    value: 'PE',
    label: 'Peru',
  },
  {
    value: 'PF',
    label: 'French Polynesia',
  },
  {
    value: 'PG',
    label: 'Papua New Guinea',
  },
  {
    value: 'PH',
    label: 'Philippines',
  },
  {
    value: 'PK',
    label: 'Pakistan',
  },
  {
    value: 'PL',
    label: 'Poland',
  },
  {
    value: 'PM',
    label: 'St. Pierre and Miquelon',
  },
  {
    value: 'PN',
    label: 'Pitcairn',
  },
  {
    value: 'PT',
    label: 'Portugal',
  },
  {
    value: 'PW',
    label: 'Palau',
  },
  {
    value: 'PY',
    label: 'Paraguay',
  },
  {
    value: 'QA',
    label: 'Qatar',
  },
  {
    value: 'RE',
    label: 'Reunion',
  },
  {
    value: 'RO',
    label: 'Romania',
  },
  {
    value: 'RS',
    label: 'Serbia',
  },
  {
    value: 'RU',
    label: 'Russian Federation',
  },
  {
    value: 'RW',
    label: 'Rwanda',
  },
  {
    value: 'SA',
    label: 'Saudi Arabia',
  },
  {
    value: 'SB',
    label: 'Solomon Islands',
  },
  {
    value: 'SC',
    label: 'Seychelles',
  },
  {
    value: 'SD',
    label: 'Sudan',
  },
  {
    value: 'SE',
    label: 'Sweden',
  },
  {
    value: 'SG',
    label: 'Singapore',
  },
  {
    value: 'SH',
    label: 'St. Helena',
  },
  {
    value: 'SI',
    label: 'Slovenia',
  },
  {
    value: 'SJ',
    label: 'Svalbard and Jan Mayen',
  },
  {
    value: 'SK',
    label: 'Slovakia',
  },
  {
    value: 'SL',
    label: 'Sierra Leone',
  },
  {
    value: 'SM',
    label: 'San Marino',
  },
  {
    value: 'SN',
    label: 'Senegal',
  },
  {
    value: 'SO',
    label: 'Somalia',
  },
  {
    value: 'SR',
    label: 'Surilabel',
  },
  {
    value: 'ST',
    label: 'Sao Tome and Principe',
  },
  {
    value: 'SV',
    label: 'El Salvador',
  },
  {
    value: 'SX',
    label: 'Sint Maarten',
  },
  {
    value: 'SY',
    label: 'Syrian Arab Republic',
  },
  {
    value: 'SZ',
    label: 'Swaziland',
  },
  {
    value: 'TC',
    label: 'Turks and Caicos',
  },
  {
    value: 'TD',
    label: 'Chad',
  },
  {
    value: 'TF',
    label: 'French Southern Terr.',
  },
  {
    value: 'TG',
    label: 'Togo',
  },
  {
    value: 'TH',
    label: 'Thailand',
  },
  {
    value: 'TJ',
    label: 'Tajikistan',
  },
  {
    value: 'TK',
    label: 'Tokelau',
  },
  {
    value: 'TM',
    label: 'Turkmenistan',
  },
  {
    value: 'TN',
    label: 'Tunisia',
  },
  {
    value: 'TO',
    label: 'Tonga',
  },
  {
    value: 'TP',
    label: 'East Timor',
  },
  {
    value: 'TR',
    label: 'Turkey',
  },
  {
    value: 'TT',
    label: 'Trinidad and Tobago',
  },
  {
    value: 'TV',
    label: 'Tuvalu',
  },
  {
    value: 'TW',
    label: 'Taiwan',
  },
  {
    value: 'TZ',
    label: 'Tanzania',
  },
  {
    value: 'UA',
    label: 'Ukraine',
  },
  {
    value: 'UG',
    label: 'Uganda',
  },
  {
    value: 'UM',
    label: 'US Minor Islands',
  },
  {
    value: 'US',
    label: 'United States',
  },
  {
    value: 'UY',
    label: 'Uruguay',
  },
  {
    value: 'UZ',
    label: 'Uzbekistan',
  },
  {
    value: 'VA',
    label: 'Vatican City State',
  },
  {
    value: 'VC',
    label: 'Saint Vincent',
  },
  {
    value: 'VE',
    label: 'Venezuela',
  },
  {
    value: 'VG',
    label: 'Virgin Islands (British)',
  },
  {
    value: 'VI',
    label: 'Virgin Islands (U.S.)',
  },
  {
    value: 'VN',
    label: 'Viet Nam',
  },
  {
    value: 'VU',
    label: 'Vanuatu',
  },
  {
    value: 'WF',
    label: 'Wallis and Futuna',
  },
  {
    value: 'WS',
    label: 'Samoa',
  },
  {
    value: 'YE',
    label: 'Yemen',
  },
  {
    value: 'YT',
    label: 'Mayotte',
  },
  {
    value: 'YU',
    label: 'Yugoslavia',
  },
  {
    value: 'ZA',
    label: 'South Africa',
  },
  {
    value: 'ZM',
    label: 'Zambia',
  },
  {
    value: 'ZR',
    label: 'Zaire',
  },
  {
    value: 'ZW',
    label: 'Zimbabwe',
  },
];
